import type { PageConfig } from './types';

export const loginPageConfig = {
  namespacesRequired: ['login', 'eula', 'cookiesConsent'],
} satisfies PageConfig;
